<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>

        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data dal</label>

                        <date-picker v-model="filtroDiario.dataOraInizio" format="DD-MM-YYYY HH:mm" value-type="timestamp" placeholder="Seleziona data iniziale" type="datetime"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Data al</label>
                        <date-picker v-model="filtroDiario.dataOraFine" format="DD-MM-YYYY HH:mm" value-type="timestamp" placeholder="Seleziona data finale" type="datetime"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="4" xl="4">
                        <label class="sa-label-data">Tipologia</label>
                        <b-form-select v-model="filtroDiario.tipologia" type="search" placeholder="Inserire Tipologia" value="" text-field="text" value-field="value" :options="tipologiaOptions">
                            <template #first>
                                <b-form-select-option :value="null" disabled>- Seleziona una tipologia - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
            </b-form>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                    <b-button type="submit" variant="info" @click="onSubmit">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                    <b-button type="reset" variant="danger" @click="onReset">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                </b-col>
            </b-row>
        </template>

        <template slot="table-body">
            <rsa-diario-component ref="cmpRsaDiario" @updateFilter="onUpdateFilter"></rsa-diario-component>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaDiarioComponent from "../../rsagestioneospiti/components/RsaDiarioComponent.vue";
export default {
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaDiarioComponent,
        DatePicker,
    },
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            tab: null,
            filtroDiario: { dataOraInizio: null, dataOraFine: null, tipologia: null },
            btnNewVisible: true,
            tipologiaOptions: [
                {
                    value: `ESEGUITA`,
                    text: `ESEGUITA`,
                },
                {
                    value: `NON ESEGUITA`,
                    text: `NON ESEGUITA`,
                },
                {
                    value: `NOTA`,
                    text: `NOTA`,
                },
                {
                    value: `PULIZIA LETTO`,
                    text: `PULIZIA LETTO`,
                },
                {
                    value: `PROGRAMMATA`,
                    text: `PROGRAMMATA`,
                },
                {
                    value: `FARMACOLOGICA`,
                    text: `FARMACOLOGICA`,
                },
            ],
            pathResource: null,
            pathResourceAccettazione: "/accettazioni",
            linkedit: null,
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            listKey: 0,
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        me.loadAccettazione();
    },
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRsaDiario.init(me.jsonData);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            // if (me.filtroDiario.dataOraInizio) {
            //     me.filtroDiario.dataOraInizio = new Date(me.filtroDiario.dataOraInizio).toISOString();
            // }

            // if (me.filtroDiario.dataOraFine) {
            //     me.filtroDiario.dataOraFine = new Date(me.filtroDiario.dataOraFine).toISOString();
            // }
            sessionStorage["filtroDiario"] = JSON.stringify(me.filtroDiario);

            me.$refs.cmpRsaDiario.resetAndReloadVoci();
        },
        onReset() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.filtroDiario = { tipologia: null };
            sessionStorage["filtroDiario"] = JSON.stringify(me.filtroDiario);
            //me.$refs.cmpRsaDiario.onInputTabs(me.tab);
            me.$refs.cmpRsaDiario.resetAndReloadVoci();
        },
        onUpdateFilter(filterData) {
            this.filtroDiario = filterData;
        },
    },
};
</script>

<style></style>
